import { useAuthStore } from '@/store/auth';
import { SUPER_ADMIN } from '@/constants/userGroups';

/**
 * Route guard that forbids super-admin users from entering agent-facing
 * dashboards (auto-call, auto-call-progressive, agent). Redirects them to
 * the AdminDashboard instead.
 */
const blockSuperAdmin = ({ to, next }) => {
  const authStore = useAuthStore();
  const isSuperAdmin = authStore.user?.user_group?.id === SUPER_ADMIN;
  if (isSuperAdmin) {
    if (to.name === 'AdminDashboard') return next();
    return next({ name: 'AdminDashboard' });
  }
  return next();
};

export default blockSuperAdmin;
